import { render, staticRenderFns } from "./misc-tile.vue?vue&type=template&id=0b70273d&scoped=true&"
import script from "./misc-tile.vue?vue&type=script&lang=js&"
export * from "./misc-tile.vue?vue&type=script&lang=js&"
import style0 from "./misc-tile.vue?vue&type=style&index=0&id=0b70273d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70273d",
  null
  
)

export default component.exports